import { SvgIcon, SvgIconProps } from '@mui/material';

const RedoIcon = (props: SvgIconProps) => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path // eslint-disable-next-line max-len
      d="M25.8346 5.66798H25.418C25.1419 5.66798 24.918 5.89185 24.918 6.16798V10.7774C23.1181 7.7116 19.783 5.6561 15.9683 5.66802C10.2855 5.68581 5.65911 10.335 5.66798 16.0178C5.6769 21.7172 10.2999 26.3347 16.0013 26.3347C18.6649 26.3347 21.0931 25.3269 22.9254 23.6718C23.1384 23.4794 23.1485 23.1484 22.9455 22.9454L22.6509 22.6509C22.4633 22.4633 22.1614 22.4545 21.9642 22.632C20.3854 24.0529 18.2957 24.918 16.0013 24.918C11.0953 24.918 7.08465 20.9459 7.08465 16.0013C7.08465 11.0953 11.0568 7.08465 16.0013 7.08465C19.4539 7.08465 22.4487 9.04619 23.93 11.918H19.168C18.8919 11.918 18.668 12.1419 18.668 12.418V12.8346C18.668 13.1108 18.8919 13.3346 19.168 13.3346H25.8346C26.1108 13.3346 26.3346 13.1108 26.3346 12.8346V6.16798C26.3346 5.89185 26.1108 5.66798 25.8346 5.66798Z"
      fill="#00532A"
    />
  </SvgIcon>
);

export default RedoIcon;
